import { Flex } from "antd";

import SortAscendingIcon from "@/icons/SortAscendingIcon";
import SortDescendingIcon from "@/icons/SortDescendingIcon";

export const SORT_OPTIONS = [
  {
    key: "-created_at",
    value: "-created_at",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Дата создания
      </Flex>
    ),
  },
  {
    key: "created_at",
    value: "created_at",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Дата создания
      </Flex>
    ),
  },
];

export const FILTER_NAMES = {
  SEARCH: "search", // поиск
  SECTIONS: "search_entity_types", // раздел, сущность
  UNIT_UUID: "unit_uuid", // рабочая группа (для админа)
  UNITS_UUIDS: "units_uuids", // рабочие группы (для пользователя)
  ACCESS_LEVEL: "type_filter", // уровень доступа (для пользователя)
  INCLUDE_DELETED: "include_deleted",
};

export const SECTIONS_OPTIONS = [
  { key: "task", value: "task", label: "Задачи" },
  { key: "object", value: "object", label: "Ресурсы" },
  { key: "file", value: "file", label: "Файлы" },
];

export const ALL_SECTION_VALUES = SECTIONS_OPTIONS.map(({ value }) => value);

export const getInitialFilters = () => ({
  search: null,
  search_entity_types: [...ALL_SECTION_VALUES],
  unit_uuid: null,
  units_uuids: [],
  type_filter: "all",
  include_deleted: false,
});

export const getSelectedSectionValues = (filters) =>
  Array.isArray(filters?.search_entity_types) ? filters.search_entity_types : [];

export const areAllSectionsSelected = (sections) =>
  sections.length === ALL_SECTION_VALUES.length &&
  ALL_SECTION_VALUES.every((value) => sections.includes(value));

export const INITIAL_TABLE_PARAMS = {
  pagination: {
    current: 1,
    pageSize: 10,
    placement: ["bottomLeft"],
    showSizeChanger: true,
  },
  filters: getInitialFilters(),
  sort: SORT_OPTIONS[0].value,
};
